<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          AUDIT TRAIL
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            Audit Trail Master Data
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon id="refresh" @click="getData()">refresh</v-icon>
          </v-flex>
          <v-flex xs4 class="my-5 pt-2">
            <v-text-field
              id="search"
              v-model="search"
              append-icon="search"
              placeholder="Search by Category and Description"
              single-line
              hide-details
              @keyup="getSearch()"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 class="pa-0 ml-7 pt-2">
            <v-select
              id="filter"
              class="select-action"
              :items="filterItems"
              v-model="filter"
              placeholder="Action Filter"
              single-line
              hide-details
              @change="getSearch()"
            ></v-select>
          </v-flex>
          <v-flex xs4 class="pl-7" style="padding-top: 35px">
            <v-menu
              ref="dateMenu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  single-line
                  dense
                  v-model="dateRangeText"
                  placeholder="Select Date Range"
                  persistent-hint
                  v-bind="attrs"
                  v-on="on"
                  append-icon="event"
                  class="range-date"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dates" no-title range>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateMenu = false"
                  >Cancel</v-btn
                >
                <v-btn text color="primary" @click="rangeDate">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-btn color="primary" dark class="mt-6 ml-7" @click="getClear()">
            clear
          </v-btn>
        </v-card-title>
        <!-- :must-sort="true"
          :options.sync="options"
          :server-items-length="totalItems"
          :sort-desc.sync="descending"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 25]
          }" -->
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :loading="loading"
          :options.sync="options"
          :server-items-length="totalItems"
          :sort-desc.sync="descending"
          :must-sort="true"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 25]
          }"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          ></v-progress-linear>
          <template v-slot:item.desc="{ item }" class="text-capitalize">
            {{ item.description ? item.description : '-' }}
          </template>
          <template v-slot:item.actionbtn="{ item }">
            <v-btn :id="'btn-detail' + item.id" @click="getDetail(item)" icon>
              <v-icon color="green">mdi-eye</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <label>No data displayed</label>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <v-dialog v-model="showDialog" id="showDialog" persistent max-width="550px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="pa-0">Audit Trail Details</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container>
            <v-row>
              <v-col cols="4" class="pa-0">
                Action Name
              </v-col>
              <v-col cols="auto" class="pa-0">
                :
              </v-col>
              <v-col cols="6" class="pa-0 pl-2">
                {{ itemDetail.action }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="pa-0">
                Category
              </v-col>
              <v-col cols="auto" class="pa-0">
                :
              </v-col>
              <v-col cols="6" class="pa-0 pl-2">
                {{ itemDetail.type }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="pa-0">
                Description
              </v-col>
              <v-col cols="auto" class="pa-0">
                :
              </v-col>
              <v-col cols="6" class="pa-0 pl-2">
                {{ itemDetail.description ? itemDetail.description : '-' }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="pa-0">
                Action By
              </v-col>
              <v-col cols="auto" class="pa-0">
                :
              </v-col>
              <v-col cols="6" class="pa-0 pl-2">
                {{ itemDetail.user ? itemDetail.user.email : '-' }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="pa-0">
                Action Time
              </v-col>
              <v-col cols="auto" class="pa-0">
                :
              </v-col>
              <v-col cols="6" class="pa-0 pl-2">
                {{ itemDetail.created_at }}
              </v-col>
            </v-row>
          </v-container>
          <v-container class="pt-0">
            <v-row>
              <v-flex xs12 class="">
                <template>
                  <v-simple-table
                    fixed-header
                    class="spending-table radius-table"
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="f-14" rowspan="2">Update Type</th>
                          <th class="f-14" colspan="2">Update</th>
                        </tr>
                        <tr>
                          <th class="f-14">Before</th>
                          <th class="f-14">After</th>
                        </tr>
                      </thead>
                      <v-perfect-scroll
                        class="drawer-menu--scroll-update"
                        :settings="scrollSettings"
                      >
                        <tbody
                          class="height-table"
                          v-if="itemUpdate.length > 0"
                        >
                          <tr v-for="(item, index) in itemUpdate" :key="index">
                            <td class="f-14">
                              {{ item.field }}
                            </td>
                            <td class="f-14">
                              {{
                                itemDetail.action === 'create'
                                  ? '-'
                                  : item.before
                              }}
                            </td>
                            <td class="f-14">
                              {{
                                itemDetail.action === 'delete'
                                  ? '-'
                                  : item.after
                              }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody class="height-table" v-else>
                          <tr>
                            <td colspan="3" class="text-center pt-2">
                              <span>No Data Displayed</span>
                            </td>
                          </tr>
                        </tbody>
                      </v-perfect-scroll>
                    </template>
                  </v-simple-table>
                </template>
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-5 px-5">
          <v-spacer></v-spacer>
          <v-btn color="#bd1e19" dark @click="showDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import ACLMixin from '../../../mixins/ACLMixin';
import paginationMixin from '../../../mixins/paginationMixin';

export default {
  components: {
    'progress-dialog': ProgressDialog
  },
  mixins: [ACLMixin, paginationMixin],
  data() {
    return {
      dateMenu: false,
      dates: [
        // new Date().toISOString().substr(0, 10),
        // new Date().toISOString().substr(0, 10)
      ],
      filterItems: ['Create', 'Update', 'Delete'],
      filter: '',
      loading: false,
      progressDialogLoading: false,
      search: '',
      isSearch: false,
      showDialog: false,
      isCreate: false,
      isEdit: false,
      id: null,
      descending: true,
      sort: '',
      totalItems: 0,
      options: {
        itemsPerPage: 5
      },
      scrollSettings: {
        maxScrollbarLength: 340
      },
      breadcrumbs: [
        {
          text: 'Audit Trail',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        }
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      headers: [
        {
          text: 'Action Name',
          value: 'action',
          sortable: false
        },
        {
          text: 'Category',
          value: 'type',
          sortable: false
        },
        {
          text: 'Description',
          value: 'desc',
          sortable: false
        },
        {
          text: 'Action By',
          value: 'user.email',
          sortable: false
        },
        {
          text: 'Action Time',
          value: 'created_at'
        },
        {
          text: 'Action',
          value: 'actionbtn',
          sortable: false
        }
      ],
      entities: [],
      items: [
        {
          id: 0,
          name: 'Update Entity',
          user: 'admin@admin.com',
          created_at: '2020-10-18 21:34:43',
          updated_at: '2020-10-29 21:34:43',
          deleted_at: '-'
        },
        {
          id: 1,
          name: 'Create Brand',
          user: 'admin@admin.com',
          created_at: '2020-10-18 21:34:43',
          updated_at: '2020-10-19 21:34:43',
          deleted_at: '-'
        },
        {
          id: 2,
          name: 'Deleted Brand',
          user: 'admin@admin.com',
          created_at: '2020-10-18 21:34:43',
          updated_at: '2020-10-19 21:34:43',
          deleted_at: '2020-10-20 21:34:43'
        }
      ],
      itemDetail: {},
      itemUpdate: [],
      name: '',
      timeout: null
    };
  },
  computed: {
    dateRangeText() {
      return this.dates.join(' ~ ');
    }
  },
  watch: {
    'options.page'() {
      this.getData();
    },
    'options.itemsPerPage'() {
      this.getData();
    },
    descending() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getSearch() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
    },
    getClear() {
      this.dates = [];
      this.search = '';
      this.filter = '';
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
    },
    getData() {
      this.progressDialogLoading = true;
      this.loading = true;
      const search = {
        desc: this.search,
        type: this.search
      };
      const filter = {
        action: this.filter
      };
      let { page, itemsPerPage } = this.options;
      if (this.isSearch) {
        page = 1;
      }
      if (this.descending) {
        this.sort = 'desc';
      } else {
        this.sort = 'asc';
      }
      const sort = this.sort;
      const date = {
        start: this.dates[0] || '',
        end: this.dates[1] || ''
      };
      this.$store
        .dispatch('auditTrail/getAllMasterData', {
          page,
          limit: itemsPerPage,
          sort,
          search,
          filter,
          date
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          this.isSearch = false;
          if (data.code === 200) {
            this.items = data.data.result;
            this.totalItems = data.data.total_data;
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getDetail(item) {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('auditTrail/detailMasterData', item.id)
        .then(data => {
          console.log(data);
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.itemDetail = item;
            this.itemUpdate = data.data;
            this.showDialog = true;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    rangeDate() {
      if (this.dates[0] && !this.dates[1]) {
        Swal.fire('Failed!', 'Please fill the end date.', 'error');
      } else {
        this.$refs.dateMenu.save(this.dates);
        this.getData();
      }
    }
  }
};
</script>

<style>
.drawer-menu--scroll-update {
  max-height: 200px;
  overflow: auto;
}
.range-date.v-text-field.v-input--dense:not(.v-text-field--outlined) input {
  padding: 4px 0 7px !important;
}
</style>
